import React from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "../components/layout/SiteChrome";

const sections = [
  {
    title: "Information We Collect",
    content: [
      "Mobile number for OTP verification and pickup scheduling",
      "Device details (brand, model, condition) to generate your price quote",
      "Pickup address provided at the time of scheduling",
      "Bank account details for payment transfer after device pickup",
    ],
  },
  {
    title: "How We Use Your Information",
    content: [
      "To verify your identity via OTP before generating a price quote",
      "To schedule and coordinate the free doorstep pickup",
      "To transfer payment to your bank account instantly after pickup",
      "To send order confirmation and pickup status notifications via SMS",
      "To improve our pricing algorithm and service quality",
    ],
  },
  {
    title: "Data Sharing",
    content: [
      "We do NOT sell your personal data to any third party",
      "Pickup agents receive only your name, phone, and address for scheduling",
      "Payment processors receive bank details solely for fund transfer",
      "We may share anonymized, aggregated data for business analytics",
    ],
  },
  {
    title: "Data Security",
    content: [
      "All data is encrypted in transit using TLS 1.3",
      "Personal data is stored on secure, access-controlled servers",
      "OTPs expire within 10 minutes and are never stored after use",
      "Bank details are encrypted and accessed only for payment processing",
    ],
  },
  {
    title: "Device Data",
    content: [
      "We do not access any data stored on your device",
      "We strongly recommend factory resetting your device before pickup",
      "Our technicians are trained not to access personal files or accounts",
      "Devices are wiped again at our processing centers as a safety measure",
    ],
  },
  {
    title: "Your Rights",
    content: [
      "Request deletion of your personal data at any time by contacting support",
      "Opt out of marketing SMS communications at any time",
      "Request a copy of all data we hold about you",
      "Raise a complaint with us or with the relevant data authority",
    ],
  },
  {
    title: "Cookies",
    content: [
      "We use essential cookies only to maintain your session and preferences",
      "We do not use advertising or tracking cookies",
      "You can disable cookies in your browser settings without affecting core functionality",
    ],
  },
  {
    title: "Contact Us",
    content: [
      "Email: privacy@truevaluemobiles.in",
      "Phone: 1800-123-4567 (toll-free, Mon–Sat 9AM–6PM)",
      "Address: True Value Mobiles Pvt. Ltd., 42 Cyber Hub, Gurugram, Haryana 122002",
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <div className="page-bg">
      <Header />

      {/* Hero */}
      <section style={{ background: "var(--indigo)", padding: "52px 20px 48px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto" }}>
          <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, color: "rgba(255,255,255,0.55)", textDecoration: "none", marginBottom: 18, transition: "color 0.2s" }}
            onMouseEnter={e => (e.currentTarget.style.color = "#fff")} onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}>
            ← Back to Home
          </Link>
          <div style={{ display: "inline-block", background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 100, padding: "4px 14px", fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.8)", marginBottom: 14 }}>
            Last updated: January 2026
          </div>
          <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(26px,4vw,40px)", color: "#fff", letterSpacing: "-0.8px", marginBottom: 12 }}>
            Privacy Policy
          </h1>
          <p style={{ fontSize: 15, color: "rgba(255,255,255,0.72)", lineHeight: 1.7, maxWidth: 560 }}>
            We take your privacy seriously. This policy explains what data we collect, how we use it, and how we keep it safe.
          </p>
        </div>
      </section>

      {/* Content */}
      <section style={{ maxWidth: 860, margin: "0 auto", padding: "56px 20px 72px" }}>
        {/* Intro box */}
        <div style={{ background: "var(--indigo-light)", border: "1.5px solid var(--border-bright)", borderRadius: 16, padding: "20px 22px", marginBottom: 40, display: "flex", gap: 14, alignItems: "flex-start" }}>
          <span style={{ fontSize: 22, flexShrink: 0 }}>🔒</span>
          <p style={{ fontSize: 14, color: "var(--indigo)", lineHeight: 1.65 }}>
            <strong>True Value Mobiles is committed to your privacy.</strong> We only collect data that is strictly necessary to process your device sale. We never sell your personal information. Your trust matters to us.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
          {sections.map((sec, i) => (
            <div key={i} style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 18, padding: "26px 24px", boxShadow: "var(--shadow-sm)" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--indigo)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, flexShrink: 0 }}>
                  {i + 1}
                </div>
                <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 18, color: "var(--text)" }}>{sec.title}</h2>
              </div>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
                {sec.content.map((item, j) => (
                  <li key={j} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "var(--text2)", lineHeight: 1.6 }}>
                    <span style={{ color: "var(--brand)", fontWeight: 700, flexShrink: 0, marginTop: 1 }}>→</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
